export enum EWalkThroughSteps {
    ListInfo = "listInfo",
    SalesSignal = "salesSignal",
    EmailAlert = "emailAlert",
    ListFilters = "listFilter",
    DataAction = "dataAction",
}

export enum OnboardingFocusQuestionType {
    BookMoreMeetings = "BookMoreMeetings",
    CloseMoreDeals = "CloseMoreDeals",
    RetainAndGrowAccounts = "RetainAndGrowAccounts",
    IncreaseSalesEfficiency = "IncreaseSalesEfficiency",
}

export enum OnboardingGoalQuestionType {
    // on wizard and hub
    FindNewProspects = "FindNewProspects",
    EnrichCsvWithCompanies = "EnrichCsvWithCompanies",
    ConnectMyCrm = "ConnectMyCrm",
    UploadListOfCompanies = "UploadListOfCompanies",
    ResearchSpecificCompany = "ResearchSpecificCompany",

    // only in hub
    SetUpAlerts = "SetUpAlerts",
    SetUpIntentAlerts = "SetUpIntentAlerts",
    CreateContactProfile = "CreateContactProfile",
    SyncMyCrm = "SyncMyCrm",
    DownloadChromeExtension = "DownloadChromeExtension",
    UploadSuppressionList = "UploadSuppressionList",
}

// common types for wizard and hub
export type CommonGoalQuestionType =
    | OnboardingGoalQuestionType.FindNewProspects
    | OnboardingGoalQuestionType.EnrichCsvWithCompanies
    | OnboardingGoalQuestionType.ConnectMyCrm
    | OnboardingGoalQuestionType.UploadListOfCompanies
    | OnboardingGoalQuestionType.ResearchSpecificCompany;
